export default [{
    _name: 'CSidebarNav',
    _children: [{
            _name: 'CSidebarNavItem',
            name: 'sidebar.dashboard',
            to: '/dashboard',
            icon: 'cil-speedometer',
            items: []
        },
        {
            _name: 'CSidebarNavDropdown',
            name: 'Withdraw',
            route: '/withdraw',
            icon: 'cil-dollar',
            items: [{
                    name: 'Pending List',
                    to: '/withdraw/pending'
                },
                {
                    name: 'Approve List',
                    to: '/withdraw/approve'
                },
                {
                    name: 'Reject List',
                    to: '/withdraw/reject'
                },
                {
                    name: 'All List',
                    to: '/withdraw/all'
                }
            ]
        },
        {
            _name: 'CSidebarNavDropdown',
            name: 'Users',
            route: '/users',
            icon: 'cil-user',
            items: [{
                    name: 'All Users',
                    to: '/users/all'
                },
                {
                    name: 'Active Users',
                    to: '/users/active'
                },
                {
                    name: 'Block Users',
                    to: '/users/block'
                }
            ]
        },
        {
            _name: 'CSidebarNavDropdown',
            name: 'Nid Verify',
            route: '/Verify',
            icon: 'cil-check-circle',
            items: [{
                    name: 'Verify Request',
                    to: '/Verify/requests'
                },
                {
                    name: 'Verified Users',
                    to: '/Verify/approved'
                },
                {
                    name: 'Reject Users',
                    to: '/Verify/rejects'
                }
            ]
        },
        {
            _name: 'CSidebarNavItem',
            name: 'Settings',
            to: '/other/setting',
            icon: 'cil-settings',
            items: []
        },
        {
            _name: 'CSidebarNavItem',
            name: 'App Update',
            to: '/other/update',
            icon: 'cil-cloud-download',
            items: []
        },
        {
            _name: 'CSidebarNavItem',
            name: 'Payment Method',
            to: '/other/payment-method',
            icon: 'cil-credit-card',
            items: []
        },
        {
            _name: 'CSidebarNavItem',
            name: 'Notification',
            to: '/other/notifications',
            icon: 'cil-bell',
            items: []
        },
        {
            _name: 'CSidebarNavItem',
            name: 'Announcements',
            to: '/other/announcements',
            icon: 'cil-bullhorn',
            items: []
        },
        {
            _name: 'CSidebarNavItem',
            name: 'Game Links',
            to: '/other/game-links',
            icon: 'cil-gamepad',
            items: []
        },
        {
            _name: 'CSidebarNavItem',
            name: 'Send Notification',
            to: '/other/send-notification',
            icon: 'cil-paper-plane',
            items: []
        }
    ]
}]